import { EventHandler } from '@n7-frontend/core';

export class DateSelectFilterEH extends EventHandler {
  public listen() {

    this.innerEvents$.subscribe(event => {
      switch(event.type){
        case 'date-select-filter.click': 
          if(event.payload.isSelected || this.dataSource.isCompareActive()) return;
          this.dataSource.onClick(event);
          this.emitOuter('click', event.payload);
          break;
        
        default:
          break;
      }
    });

    this.outerEvents$.subscribe(event => {
      if(event.type === 'chart-layout.compare-checkbox-change'){
        this.dataSource.onCompareCheckboxChange(event.payload);
      }
    });
  }
}